/**
 * Paramedie Gelderse Vallei
 *
 * @author Robuust
 * @author Jurriën Peters <jurrien@robuust.digital>
 */

import { Controller } from '@hotwired/stimulus';

/**
 * Controller for tabs.
 */
export default class extends Controller {
  static targets = ['tab', 'content'];

  static classes = ['active'];

  /**
   * Toggle accordion.
   *
   * @param {Event} e
   */
  toggle(e) {
    // Toggle tabs
    this.tabTargets.forEach((tabTarget, tabIndex) => {
      tabTarget.classList.toggle(this.activeClass, e.params.index === tabIndex);
    });

    // Toggle content if available
    if (this.hasContentTarget) {
      this.contentTargets.forEach((contentTarget, contentIndex) => {
        contentTarget.classList.toggle(this.activeClass, e.params.index === contentIndex);
      });
    }
  }
}
